// extracted by mini-css-extract-plugin
export default {"pipelineDetailsRow":"review_pipelineDetailsRow__OmZGz","rowSubTitle":"review_rowSubTitle__knFjm","rowValues":"review_rowValues__EmlhA","actionBtns":"review_actionBtns__e-cOn"};